export default function AxiosRequestError(error) {
  return Promise.reject(error);
}
